class RetainScrollPosition {
    constructor(activeElement) {
        this.getScrollPosition(activeElement);
    }
    getScrollPosition = (activeElement) => {
        if (activeElement) {
            try {
                // Check if the element with id 'active' exists
                let nav = document.querySelector(".sd-page-navigation");
                let left = sessionStorage.getItem('nav-scroll-position');

                // Check if 'nav-scroll-position' is stored in sessionStorage
                if (left !== null) {
                    nav.scrollLeft = parseInt(left, 10);
                }

                // Add a pagehide event listener to store the scroll position
                window.addEventListener('pagehide', () => {
                    sessionStorage.setItem('nav-scroll-position', nav.scrollLeft);
                });
            } catch (error) {
                console.log(error);
            }
        }
    }
}
export default RetainScrollPosition;